import * as React from 'react';
import * as styled from './styled';
import {useContext} from '../../hooks/useContext';
import Switch, {SwitchVariant} from 'components/Switch';
import {ViewMode} from '../../types';

/**
 * The header of task progress.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Header(): React.ReactElement {
  const {
    states: {
      mode,
    },
  } = useContext();

  /**
   * Render mode switch.
   * @return {JSX.Element}
   */
  function renderModeSwitch(): JSX.Element {
    /**
     * Get checked.
     * @return {boolean}
     */
    function getChecked(): boolean {
      return mode.state === ViewMode.Page;
    }

    /**
     * The change event handler.
     * @param {React.ChangeEvent<HTMLInputElement>} event
     */
    function handleChange(event: React.ChangeEvent<HTMLInputElement>): void {
      if (!event.target.checked) {
        mode.setState(ViewMode.Carousel);
      } else {
        mode.setState(ViewMode.Page);
      }
    }

    return (
      <Switch
        label="Все вопросы на одной странице"
        variant={SwitchVariant.Accent}
        checked={getChecked()}
        onChange={handleChange}
      />
    );
  }

  return (
    <styled.Wrapper>
      {renderModeSwitch()}
    </styled.Wrapper>
  );
}
